import { ReactNode } from "react";
import { Stack } from "@mui/material";

import Legend from "components/partials/legent/legend";

type FormGroupProps = {
  legend?: string;
  legendSize?: "sm" | "lg";
  spacing?: number;
  direction?: "column" | "row";
  justifyContent?: string;
  children: ReactNode;
};

export const FormGroup = ({
  legend,
  legendSize = "lg",
  spacing = 4,
  direction = "column",
  justifyContent,
  children,
}: FormGroupProps) => {
  const headerMargin = spacing / 2;
  return (
    <Stack
      component="fieldset"
      spacing={spacing}
      direction={direction}
      sx={{ justifyContent, border: 0, m: 0, p: 0, minWidth: 0 }}>
      {legend && (
        <Legend
          size={legendSize}
          sx={{ mb: direction === "column" ? -headerMargin : headerMargin }}>
          {legend}
        </Legend>
      )}
      {children}
    </Stack>
  );
};
